import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => {
  const isDark = theme.palette.type === 'dark'
  const {
    palette: {
      blue_300: { main: blue300 } = {},
      gray_400: { main: gray400 } = {},
      gray_50: { main: gray50 } = {},
      dark_50: { main: dark50 } = {},
      dark_400: { main: dark400 } = {},
      white100: { main: white100 } = {}
    } = {}
  } = theme
  return {
    formControl: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
      width: '100%',
      '& .MuiAutocomplete-inputRoot.MuiOutlinedInput-root.MuiOutlinedInput-marginDense':
      {
        minHeight: '40px',
        padding: '0 4px',
        '& .MuiOutlinedInput-input': {
          padding: '6px 4px !important'
        }
      },
      '& .MuiOutlinedInput-root': {
        height: 40,
        padding: '0 4px',
        backgroundColor: isDark
          ? theme.palette.dark_400.main + '!important'
          : gray50 + '!important',
        borderRadius: '8px',
        '& .MuiOutlinedInput-input': {
          padding: '2px 4px !important',
          color: isDark ? dark50 + '!important' : gray400 + '!important',
          '&.Mui-disabled': {
            cursor: 'pointer'
          }
        },
        '& .MuiSelect-outlined': {
          paddingTop: 10,
          paddingBottom: 10
        }
      },
      '& label': {
        color: isDark ? dark50 : gray400
      }
    },
    chip: {
      color: white100,
      borderRadius: '4px',
      height: '20px',
      fontSize: '11px',
      marginLeft: '4px',
      backgroundColor: blue300
    },
    chipUsers: {
      color: isDark ? dark50 : gray400,
      height: '20px',
      fontSize: '11px',
      marginLeft: '4px',
      textTransform: 'uppercase'
    },
    checkbox: {
      marginRight: 8,
      padding: 0,
      color: isDark
        ? theme.palette.dark_50.main + '!important'
        : theme.palette.gray_400.main + '!important',
      '&.Mui-checked': {
        color: theme.palette.blue_300.main + '!important'
      },
      '& .MuiSvgIcon-root': {
        color: 'inherit'
      }
    },
    listbox: {
      maxHeight: '200px',
      overflowY: 'auto',
      ...theme.scrollbarStyles,
      '& .MuiAutocomplete-option': {
        padding: '0px 8px',
        margin: '0',
        color: isDark
          ? theme.palette.dark_50.main + '!important'
          : theme.palette.gray_400.main + '!important',
        '&:not(.Mui-selected)': {
          color: isDark
            ? theme.palette.dark_50.main + '!important'
            : theme.palette.gray_400.main + '!important'
        }
      }
    },
    selectedText: {
      display: 'block',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '100%'
    },
    menuPaper: {
      maxHeight: '300px'
    },
    searchBox: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      padding: '8px 16px',
      borderBottom: `1px solid ${isDark ? theme.palette.dark_300?.main || '#3a3a4a' : theme.palette.gray_200?.main || '#e0e0e0'}`,
      color: isDark ? dark50 : gray400
    },
    searchInput: {
      flex: 1,
      fontSize: '14px'
    }
  }
})
